import type { BlogPost } from '#app/data/blog'

export function ArticleHeader({ post }: { post: BlogPost }) {
	return (
		<div className="mx-auto max-w-3xl">
			<span className="mb-4 inline-block rounded-full bg-[#F8F9FA] px-4 py-1.5 text-sm font-medium text-[#32302F]">
				{post.category}
			</span>

			<h1 className="mb-6 font-['Futura_Hv_BT'] text-[28px] leading-tight text-[#32302F] md:text-[40px]">
				{post.title}
			</h1>

			<p className="mb-8 text-lg leading-relaxed text-[#747474]">
				{post.excerpt}
			</p>
		</div>
	)
}
